import axios from 'axios'
import { logout } from '@/features/auth/services/authService'
import { EnvironmentVariable } from './constants'
import { auth } from '@/features/auth/firebaseConfig'
import { getAuthToken, clearAuthTokenCache } from './getAuthToken'

const { localEnvConfig } = EnvironmentVariable

const HTTPInstance = axios.create({
  baseURL: localEnvConfig.API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

HTTPInstance.interceptors.request.use(async config => {
  if (auth.currentUser) {
    const token = await getAuthToken()
    config.headers.set('Authorization', `Bearer ${token}`)
  }
  return config
})

HTTPInstance.interceptors.response.use(
  res => res,
  async error => {
    const { response, config } = error || {}

    if (response?.status === 401 && auth.currentUser && config && !config.isRetry) {
      try {
        ;(config as unknown as { isRetry: boolean }).isRetry = true
        const fresh = await getAuthToken(true)
        config.headers.set('Authorization', `Bearer ${fresh}`)
        return HTTPInstance(config)
      } catch {
        // fall through to logout below
      }
    }

    if (response?.status === 401) {
      clearAuthTokenCache()
      localStorage.removeItem('access_token')
      localStorage.removeItem('restaurantId')
      localStorage.removeItem('currency')
      await logout()
    }

    return Promise.reject(error)
  }
)

export { HTTPInstance }
